if (!customElements.get('form-validation')) {
  class FormValidation extends HTMLElement {
    constructor() {
      super();
    }

    setFieldValidity(input) {
      const field = input.closest('.js-field');

      input.setAttribute('aria-invalid', !input.validity.valid);

      if (!field) {
        return;
      }

      field.classList.toggle('has-error', !input.validity.valid);

      field
        .querySelector('[data-error-message]')
        ?.classList.toggle('hidden', input.validity.valid);
    }

    updateSubmitButtonState() {
      const hasErrorFields =
        this.form.querySelectorAll('.js-field.has-error').length > 0;
      const hasInvalidFields =
        this.form.querySelectorAll('[required]:invalid').length > 0;

      this.submitBtn.classList.toggle('has-error', hasErrorFields);

      if (!hasErrorFields) {
        this.submitBtn.classList.toggle('is-inactive', hasInvalidFields);
      }
    }

    handleSubmit(event) {
      const isValid = this.form.reportValidity();

      if (!isValid) {
        event.preventDefault();
      }
    }

    setEventHandlers() {
      this.form.addEventListener('submit', this.handleSubmit.bind(this));

      for (const input of this.form.elements) {
        if (input.hasAttribute('data-no-validate')) continue;

        input.addEventListener('invalid', (event) => {
          event.preventDefault();
          this.setFieldValidity(input);
        });

        input.addEventListener('change', (event) => {
          this.setFieldValidity(input);
          this.updateSubmitButtonState();
        });
      }
    }

    connectedCallback() {
      this.form = this.querySelector('form');
      if (!this.form) return;

      this.submitBtn = this.form.querySelector('[data-submit-btn]');

      this.setEventHandlers();
    }
  }

  customElements.define('form-validation', FormValidation);
}
